import "./taskManager.css";
import Task from "../Task/Task";
import { useState, useEffect } from "react";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";
import AddTask from "../AddTask/AddTask";

function TaskManager() {
  const [openAddModal, setOpenAddModal] = useState(false);
  const [tasks, setTasks] = useState([]);

  /* function to get all tasks from firestore in realtime */
  useEffect(() => {
    const taskColRef = query(
      collection(db, "users"),
      orderBy("created", "desc")
    );
    onSnapshot(taskColRef, (snapshot) => {
      setTasks(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }))
      );
    });
  }, []);

  return (
    <div className="taskManager">
      <div className="taskManager__container">
        <button onClick={() => setOpenAddModal(true)}>Create User +</button>
        <div className="taskManager__tasks">
          <div className="dataGrid">
            <table>
              <thead>
                <tr>
                  <th data-type="text-short">
                    First name <span className="resize-handle"></span>
                  </th>
                  <th data-type="text-short">
                    Last name <span className="resize-handle"></span>
                  </th>
                  <th data-type="text-short">
                    Followers <span className="resize-handle"></span>
                  </th>

                  <th data-type="text-short">
                    Instagram <span className="resize-handle"></span>
                  </th>

                  <th data-type="text-long">
                    Other <span className="resize-handle"></span>
                  </th>
                  <th data-type="text-long">
                    Onay <span className="resize-handle"></span>
                  </th>
                  <th data-type="text-long">
                    Edit <span className="resize-handle"></span>
                  </th>
                  <th data-type="text-long">
                    Delete <span className="resize-handle"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task) => (
                  <Task
                    id={task.id}
                    key={task.id}
                    completed={task.data.completed}
                    name={task.data.name}
                    surname={task.data.surname}
                    username={task.data.username}
                    followers={task.data.followers}
                    age={task.data.age}
                    city={task.data.city}
                    email={task.data.email}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {openAddModal && (
        <AddTask onClose={() => setOpenAddModal(false)} open={openAddModal} />
      )}
    </div>
  );
}

export default TaskManager;
